export const HandleClick = (e, url) => {
	e.preventDefault();
	if (url && url.indexOf("http") > -1) {
		window.open(url, "_blank");
	} else {
		window.location.href = url;
	}
};
